export default function(address, address2, city, state, zipcode) {
    let slug = [address, address2, city, state, zipcode].filter(v => v).join('+').replace(/,/g, '').replace(/ /g, '+');
    return `https://maps.apple.com/?address=${slug}`
}
